<template>
<span v-if="disabled && printMode" class='showText'>{{lr_dateFormat(value2, myformat)}}</span>
<!-- <div v-else> -->
    <div v-else-if="viewMode" :class="{'diy-time-box': selectVal == '自定义'}">
        <!-- v-if="(viewMode && selectVal == '自定义') || !viewMode" -->
        <div>
            <el-select :clearable="clearable" style="width: 100%;" v-model="selectVal" :size="size" filterable>
                <el-option
                v-for="i in timeTypeOptions"
                :key="i"
                :label="i"
                :value="i">
                </el-option>
            </el-select>
        </div>
        <div v-if="selectVal == '自定义'">
            <div class="flex" style="padding-left: 8px">
                前 
                <!-- controls-position="right" -->
                <el-input-number style="margin-left: 12px" v-model="startData.val" :size="size"  @change="diyChange" :min="0" :max="365"></el-input-number>
                <el-select v-model="startData.unit" @change="diyChange" :size="size">
                    <el-option
                        v-for="i in unitTypes"
                        :key="i"
                        :label="i"
                        :value="i">
                    </el-option>
                </el-select>
            </div>
            <div class="flex" style="padding-left: 8px">
                后
                <el-input-number style="margin-left: 12px" v-model="endData.val" :size="size" @change="diyChange" :min="0" :max="365"></el-input-number>
                <el-select v-model="endData.unit" @change="diyChange" :size="size">
                    <el-option
                        v-for="i in unitTypes"
                        :key="i"
                        :label="i"
                        :value="i">
                    </el-option>
                </el-select>
            </div>
        </div>
        
    </div>
    <el-date-picker
        v-else
        ref="main"
        class="l-time"
        :format="myformat"
        :valueFormat="myformat"
        :placeholder="placeholder"
        :startPlaceholder="startPlaceholder"
        :endPlaceholder="endPlaceholder"
        :picker-options="pickerOptions"
        :readonly="readonly"
        :disabled="disabled"
        :editable="editable"
        :clearable="clearable"
        :default-time="dateType.indexOf('range') > -1 ? ['00:00:00', '23:59:59'] : defaultTime"
        :size="size"
        :type="dateType"
        :align="align"
        :rangeSeparator="rangeSeparator"
        :defaultValue="defaultValue"
        :unlink-panels="unlinkPanels"
        @blur="blur"
        @change="$emit('change',value2)"


        v-model="value2"
    >
    </el-date-picker>
<!-- </div> -->


</template>
<script>
import { validatenull } from '@util/validate';
export default {
  name:'l-date',
  props: {
    value:{},
    placeholder:String,
    startPlaceholder:String,
    endPlaceholder:String,
    readonly:Boolean,
    disabled:Boolean,
    printMode:Boolean,
    editable:Boolean,
    
    clearable:{
        type:Boolean,
        default:true
    },
    size:{
        type:String,
        default:'mini'
    },
    dateType:{
        type:String,
        default:'date'
    },
    align:String,
    rangeSeparator:{
        type:String,
        default:'-'
    },
    defaultValue:Date,
    defaultTime:{
        type:String,
        default:''
    },

    format:String,
   
    selectableRange:[String,Array],

    unlinkPanels:{
        type:Boolean,
        default:true
    },
    viewMode: { // 要选择动态时间范围时，需要置为true
        default: false
    },
    unitTypes: {
        default: () => {
            return ['日', '周', '月', '季度', '年']
        }
    }
   
    
  },
  created(){
  },
  data () {
      return {
        startData: {
            val: 1,
            unit: '日'
        },
        endData: {
            val: 0,
            unit: '日'
        }
      }
  },
    mounted() {
    this.valChange()
  },
  computed:{
      value2:{
          get(){
              if(this.isRange){
                  if(validatenull(this.value)){
                    return ["",""];
                  }
                  else{
                    return this.value.split(' - ');
                  }
              }
              else{
                  return this.value;
              }
          },
          set(newValue){
                if(this.isRange){
                    if(validatenull(newValue)){
                        this.$emit('input', '');
                    }
                    else{
                        this.$emit('input',`${(newValue[0] && newValue[0].getDate) ? this.lr_dateFormat(newValue[0], 'yyyy-MM-dd HH:mm:ss') : newValue[0]} ${this.rangeSeparator} ${(newValue[1] && newValue[1].getDate) ? this.lr_dateFormat(newValue[1], 'yyyy-MM-dd HH:mm:ss') : newValue[1]}`);
                    }
                   
                }
                else {
                    this.$emit('input', (newValue && newValue.getDate) ? this.lr_dateFormat(newValue, 'yyyy-MM-dd HH:mm:ss') : newValue);
                }
          }
      },
      myformat(){
          let format = ''
          switch (this.dateType) {
            case 'year':        
                    format = 'yyyy'
                    break
            case 'month':        
                    format = 'yyyy-MM'
                    break
            case 'date':        
                    format = 'yyyy-MM-dd'
                    break    
            case 'datetime':
                format = 'yyyy-MM-dd HH:mm:ss'
                break
            case 'datetimerange':
                format = 'yyyy-MM-dd HH:mm'
                break
            case 'daterange':
                format = 'yyyy-MM-dd'
                break 
            case 'monthrange':
                format = 'yyyy-MM'
                break 
          }
          return this.format || format
          
      },
      isRange(){
          return ['datetimerange','daterange','monthrange'].includes(this.dateType)
      },
      pickerOptions () {
        if (this.isRange) return this.PickerOptions
        return {}
      },
    //   viewMode () { // 视图模式可以选今天 昨天 本周 上周等动态范围时间
    //     return this.canSelectCurrent && ['daterange', 'datetimerange'].includes(this.dateType)
    //   },
      selectVal: {
        get: function() {
            if (!this.currentTimeTypes.includes(this.value) && this.value) {
                // let val = `自定义时间范围-${this.startData.val} ${this.startData.unit}-${this.endData.val} ${this.endData.unit}`
                let arr = this.value.split('-')
                this.startData = {
                    val: arr[1].split(' ')[0],
                    unit: arr[1].split(' ')[1],
                }
                this.endData = {
                    val: arr[2].split(' ')[0],
                    unit: arr[2].split(' ')[1],
                }
                return '自定义'
            }
            return this.value
        },
        set: function (val) {
            if (val == '自定义') return this.diyChange()
            this.$emit('input', val)
            this.$emit('change', val)
        }
      },
      timeTypeOptions () {
        return this.currentTimeTypes.concat(['自定义'])
      }
    },
    watch: {
        value() {
            this.valChange()
        }
    },
    methods: {
      valChange() { 
        let val = this.value
          if ((val && val.includes && val.includes('T') && val.includes('Z')) || (val && val.getDate)) {
            let format = 'yyyy-MM-dd HH:mm:ss'
            if (this.isRange) {
                let arr = val.split(' - ')
                this.$emit('input', `${this.lr_dateFormat(arr[0], format)} ${this.rangeSeparator} ${this.lr_dateFormat(arr[1], format)}`);
            }
            else{
                this.$emit('input', this.lr_dateFormat(val, format));
            }
          }
      },
      diyChange () {
        let val = `自定义时间范围-${this.startData.val} ${this.startData.unit}-${this.endData.val} ${this.endData.unit}`
        this.$emit('input', val)
        this.$emit('change', val)
      },
      focus () {
        this.$refs.main.focus()
      },
      blur () {
        this.$emit('blur')
      }
  }
}
</script>
